import { List, ListItem, makeStyles } from "@material-ui/core";

import { FileField } from "react-admin";
import { get } from "lodash";

const stopPropagation = (e) => e.stopPropagation();

const useStyles = makeStyles((theme) => ({
  item: {
    paddingLeft: theme.spacing(0),
  },
  root: {
    "& a": {
      maxWidth: "200px ",
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "inline-block",
    },
  },
}));

const FileFieldWrapper = ({ ...props }) => {
  const { source, record } = props;
  const url = get(record, source);
  const classes = useStyles();
  return (
    <ListItem className={classes.item}>
      <FileField
        {...props}
        source="url"
        record={{ ...record, url }}
        className={classes.root}
        onClick={stopPropagation}
      />
    </ListItem>
  );
};

const MediaField = ({ source, ...props }) => {
  const docMedia = get(props?.record, source);
  return (
    <List>
      {docMedia?.map((media, key) => (
        <FileFieldWrapper
          source="file.path"
          title="file.name"
          record={media}
          key={key}
        />
      ))}
    </List>
  );
};
export default MediaField;
